import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../utils/axios';
import UnauthorizedPage from '../exceptions/UnauthorizedPage';
import './AdminUserTransactionsPage.css';

function decodeJWT(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(decodeURIComponent(atob(base64).split('').map((character) =>
            '%' + ('00' + character.charCodeAt(0).toString(16)).slice(-2)
        ).join('')));
    } catch (error) {
        return null;
    }
}

function AdminUserTransactionsPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [authorized, setAuthorized] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        const decoded = token ? decodeJWT(token) : null;
        if (!decoded || String(decoded.role).toUpperCase() !== 'ADMIN') {
            setLoading(false);
            return;
        }

        setAuthorized(true);
        Promise.all([
            axiosInstance.get(`/api/private/user/${id}`),
            axiosInstance.get(`/api/private/transactions/${id}`)
        ])
            .then(([userResponse, transactionResponse]) => {
                setUser(userResponse.data);
                setTransactions(Array.isArray(transactionResponse?.data) ? transactionResponse.data : []);
            })
            .catch(() => setError('Kasutaja tehingute laadimine ebaõnnestus.'))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) {
        return <div className="admin-transactions-page">Laadimine...</div>;
    }

    if (!authorized) {
        return <UnauthorizedPage />;
    }

    return (
        <div className="admin-transactions-page">
            <div className="admin-transactions-container">
                <button className="back-btn" onClick={() => navigate('/admin')}>
                    Tagasi admini lehele
                </button>
                <h1>{(user?.firstName && user?.lastName ? `${user.firstName} ${user.lastName}` : user?.username) || `Kasutaja #${id}`} tehingud</h1>
                {error ? <p className="transactions-error">{error}</p> : (
                    transactions.length === 0 ? (
                        <p className="transactions-empty">Sellel kasutajal tehinguid ei ole.</p>
                    ) : (
                        <div className="transaction-table-wrapper">
                            <table className="transaction-table">
                                <thead>
                                    <tr>
                                        <th>Aeg</th>
                                        <th>Kirjeldus</th>
                                        <th>Summa</th>
                                        <th>Saldo pärast</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactions.map((transaction) => (
                                        <tr key={transaction.id}>
                                            <td>{new Date(transaction.createdAt).toLocaleString('et-EE')}</td>
                                            <td>{transaction.description}</td>
                                            <td className={transaction.amount >= 0 ? 'transaction-positive' : 'transaction-negative'}>
                                                {transaction.amount >= 0 ? '+' : ''}{Number(transaction.amount).toFixed(2)} €
                                            </td>
                                            <td>{Number(transaction.balanceAfter).toFixed(2)} €</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )
                )}
            </div>
        </div>
    );
}

export default AdminUserTransactionsPage;
